/****************************************************
 * Module Name:  locationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class LocationProxy {
  static GetAllLocation = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/location",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllLocationDetailMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/location/detail/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllLocationDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/location/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleLocation = (locationId, callback) => {
    let params = {
      id: locationId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/location",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckLocationAvailable = (location, callback) => {
    let params = {
      location: location,
    };

    restAPICall(
      Constants.MANAGER_URL + "/location/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddLocation = (location, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/location",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(location),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateLocation = (location, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/location",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(location),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteLocation = (location, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/location",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(location),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
